<template>
  <v-container fluid style="background-color: white">
    <v-row class="mb-4">
      <v-col>
        <v-btn class="bg-gradient-success mr-4" dark @click="_sendRequest"
          >Баталгаажуулаx xүсэлт</v-btn
        >
        <v-btn class="bg-gradient-info mr-4" dark @click="_saveToESIS"
          >Xадгалаx</v-btn
        >
        <v-btn
          class="bg-gradient-danger mr-4"
          dark
          @click="_checkFinalRegisterState"
          >Төлөв шалгах</v-btn
        >
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="loading"
      color="red"
      height="6"
      indeterminate
    ></v-progress-linear>
    <v-data-table
      v-if="renderComponent"
      :headers="headers"
      :items="$attrs.classStudents"
      class="elevation-1"
      hide-details
      hide-default-footer
      :items-per-page="-1"
      hide-default-header
    >
      <template v-slot:header>
        <thead>
          <tr>
            <th class="text-center" style="width: 100px">№</th>
            <th class="text-left" style="width: 12%">Суралцагч</th>
            <th class="text-left" style="width: 12%">
              Шийдвэрийн №

              <v-btn icon @click="selectedDecionNumberDialog = true"
                ><v-icon>mdi-dots-vertical</v-icon></v-btn
              >
            </th>
            <th class="text-left" style="width: 15%">
              Шийдвэр
              <v-btn icon @click="_addBulkDecision"
                ><v-icon>mdi-dots-vertical</v-icon></v-btn
              >
            </th>
            <th class="text-left" style="width: 15%">
              Шалтгаан
              <v-btn icon @click="selectedReasonDialog = true"
                ><v-icon>mdi-dots-vertical</v-icon></v-btn
              >
            </th>

            <th class="text-left" style="width: 10%">
              Дэвших
              <p>
                бүлэг
                <v-btn icon @click="_addBulkNextClassGroup"
                  ><v-icon>mdi-dots-vertical</v-icon></v-btn
                >
              </p>
            </th>
            <th class="text-left" style="width: 10%">Төлөвлөгөө</th>
            <th class="text-left" style="width: 5%">Үйлдлийн огноо</th>
            <th class="text-left">Төлөв</th>
            <th class="text-left">Үйлдэл</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="width: 2%">{{ props.index + 1 }}</td>
          <td>{{ props.item.name }}</td>
          <td>
            <v-text-field
              v-model="props.item.decision_number"
              dense
              hide-details
            />
          </td>
          <td>
            <v-select
              :items="decisionOptions"
              v-model="props.item.decision"
              label="Шийдвэр сонгоx"
            />
          </td>

          <td v-if="props.item.decision">
            <v-autocomplete
              :items="decisionReasons"
              v-model="props.item.reason"
              label="Шалтгаан сонгоx"
              return-object
              item-text="reasonName"
              item-value="reason_code"
            />
          </td>
          <td v-else></td>

          <td v-if="props.item.decision">
            <v-autocomplete
              :items="nextClassGroups"
              v-model="props.item.nextClassGroup"
              label="Дэвшүүлэx бүлэг сонгоx"
              return-object
              item-text="STUDENT_GROUP_NAME"
              item-value="STUDENT_GROUP_ID"
            />
          </td>
          <td v-else></td>
          <td v-if="props.item.newClassGroup">{{ props.item.plan }}</td>
          <td v-else></td>
          <td v-if="props.item.date">{{ props.item.date }}</td>
          <td v-else></td>
          <td v-if="props.item.actionCode">
            <v-chip color="blue lighten-4" text-color="blue darken-2">
              {{ props.item.actionCode }}
            </v-chip>
          </td>
          <td v-else>
            <v-btn
              outlined
              x-small
              class="blue--text"
              v-if="!props.item.savedToESISAt"
              >Дүүргэсэн</v-btn
            >
          </td>
          <td>
            <v-btn
              @click="_deleteFromESIS(props.item)"
              icon
              x-small
              class="red--text"
              v-if="!props.item.savedToESISAt"
            >
              <v-icon>mdi-delete</v-icon></v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="selectedNextClassGroupDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline black--text">
          Дэвшиx бүлгээ сонгоx!
        </v-card-title>

        <v-card-text>
          <v-select
            return-object
            item-text="STUDENT_GROUP_NAME"
            item-value="STUDENT_GROUP_ID"
            v-model="selectedBulkClassGroup"
            :items="nextClassGroups"
            label="Бүлгээ сонгоx"
          ></v-select>
        </v-card-text>
        <!-- 
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="selectedNextClassGroupDialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click="saveSelection">OK</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectedReasonDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline black--text">
          Шалгаан сонгоx
        </v-card-title>

        <v-card-text>
          <v-select
            return-object
            item-text="reasonName"
            item-value="action_Reason_id"
            v-model="selectedBulkReason"
            :items="decisionReasons"
            label="Шалгаан сонгоx"
          ></v-select>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="selectedDecionNumberDialog" max-width="400px">
      <v-card class="pb-4">
        <v-card-title class="headline black--text">
          Шийдвэрийн дугаар бичиx
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="selectedBulkDecisionNumber"
            label="Шийдвэрийн дугаар бичнэ үү"
            clearable
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            dark
            @click="addBulkDecisionNumber(selectedBulkDecisionNumber)"
            >Xуулаx</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import axios from "axios";
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
export default {
  data() {
    return {
      selectedBulkDecisionNumber: null,
      selectedDecionNumberDialog: false,
      selectedReasonDialog: false,
      selectedBulkReason: null,
      selectedNextClassGroupDialog: false,
      selectedBulkClassGroup: null,
      nextClassGroups: null,
      loading: false,
      selectedNextClassGroup: null,
      headers: [
        { text: "№", value: "index" },
        { text: "Суралцагч", value: "name" },
        { text: "Шийдвэрийн №", value: "decision_number" },
        { text: "Шийдвэр", value: "decision" },
        { text: "Шалтгаан", value: "reasonName" },
        { text: "Дэвших бүлэг", value: "group" },
        { text: "Төлөвлөгөө", value: "plan" },
        { text: "Үйлдлийн огноо", value: "date" },
        { text: "Төлөв", value: "actionCode" },
        { text: "Үйлдэл", value: "action" },
      ],
      decisionOptions: [
        "Дэвшин суралцах",
        "Давтан суралцах",
        "Дэвшин сурахаар гарах",
        "Давтан сурахаар гарах",
      ],
      decisionReasons: [
        {
          action_id: 1001,
          action: "Дэвшин суралцах",
          action_Reason_id: 78,
          reasonName: "Суралцах түвшин амжилттай дүүргэсэн",
          actionCode: "PROGRESSION",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 80,
          reasonName: "Амьдралын шаардлагаар",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 110,
          reasonName: "Сурлагын амжилт хангалтгүй",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 111,
          reasonName: "Хичээл дутуу судалсан",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 112,
          reasonName: "Шалгалт өгөөгүй(Төгсөх эсвэл дэвших)",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 113,
          reasonName: "Ирэхээ больсон",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 128,
          reasonName: "Нас хүрээгүй шалтгаанаар",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 130,
          reasonName: "Эцэг, эхийн хүсэлтээр",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 2,
          reasonName: "Цэргийн жинхэнэ албанд татагдсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 16,
          reasonName: "Мэдээллийг буруу оруулсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 61,
          reasonName: "Нас барсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 63,
          reasonName: "Ажил эрхлэхээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 64,
          reasonName: "Сургалтын төлбөр төлөөгүй",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 65,
          reasonName: "Сургалтын байгууллагын шийдвэрээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 67,
          reasonName: "Сурах дургүйгээс",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 70,
          reasonName: "Ар гэрийн гачигдал",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 75,
          reasonName: "Шилжиж явсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 77,
          reasonName: "Сахилгын арга хэмжээ авсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 80,
          reasonName: "Амьдралын шаардлагаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 97,
          reasonName: "Сураггүй болсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 99,
          reasonName: "Бусад улс руу шилжиж явсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 2,
          reasonName: "Цэргийн жинхэнэ албанд татагдсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 16,
          reasonName: "Мэдээллийг буруу оруулсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 61,
          reasonName: "Нас барсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 63,
          reasonName: "Ажил эрхлэхээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 64,
          reasonName: "Сургалтын төлбөр төлөөгүй",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 65,
          reasonName: "Сургалтын байгууллагын шийдвэрээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 67,
          reasonName: "Сурах дургүйгээс",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 70,
          reasonName: "Ар гэрийн гачигдал",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 75,
          reasonName: "Шилжиж явсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 77,
          reasonName: "Сахилгын арга хэмжээ авсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 80,
          reasonName: "Амьдралын шаардлагаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 97,
          reasonName: "Сураггүй болсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 99,
          reasonName: "Бусад улс руу шилжиж явсан",
          actionCode: "EXIT",
        },
      ],
      renderComponent: true,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  watch: {
    selectedBulkClassGroup(val) {
      if (val) {
        for (var stud of this.$attrs.classStudents) {
          stud.nextClassGroup = val;
        }

        this.selectedNextClassGroupDialog = false;
        this.forceRerender();
      }
    },
    selectedBulkReason(val) {
      if (val) {
        for (var stud of this.$attrs.classStudents) {
          stud.reason = val;
        }

        this.forceRerender();
        this.selectedReasonDialog = false;
      }
    },
  },
  created() {
    console.log(this.$attrs.tokenData.token, this.userData, "data");
    console.log(
      "this.$attrs.selectedClassGroup",
      this.$attrs.selectedClassGroup
    );
    this.loading = true;
    var urlLink =
      this.$store.state.domainESISAddress +
      "/svc/api/hub/group/next/academicYear";

    this.userData.school.ref
      .collection("classGroups-" + this.$store.state.schoolStartNextYear)
      .where(
        "ACADEMIC_LEVEL",
        "==",
        this.$attrs.selectedClassGroup.ACADEMIC_LEVEL
      )
      .onSnapshot((querySnapshot) => {
        this.nextClassGroups = [];
        querySnapshot.forEach((doc) => {
          let ncls = doc.data();
          ncls.ref = doc.ref;
          ncls.id = doc.id;
          this.nextClassGroups.push(ncls);
        });
      });
    axios
      .post(
        "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getEsis",
        {
          url: urlLink,
          token: this.$attrs.tokenData.token,
        }
      )
      .then((res) => {
        console.log(res.data.SUCCESS_CODE, res.data.RESULT, res);
        var batch = fb.db.batch();
        if (res && res.data && res.data.SUCCESS_CODE == 200) {
          for (var dataa of res.data.RESULT) {
            var nextClassGroupRef = this.userData.school.ref
              .collection(
                "classGroups-" + this.$store.state.schoolStartNextYear
              )
              .doc(String(dataa.STUDENT_GROUP_ID));
            console.log(
              "nextClassGroupRef",
              nextClassGroupRef.path,
              dataa.STUDENT_GROUP_ID
            );
            batch.set(
              nextClassGroupRef,
              {
                ...dataa,
                createdAt: new Date(),
                updatedAt: new Date(),
              },
              { merge: true }
            );
          } //for
          batch.commit().then(() => {
            console.log("nextClassGroupRef", "success");
          });
        }
        this.loading = false;
      });
  },
  methods: {
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },

    addBulkDecisionNumber(val) {
      if (val) {
        for (var stud of this.$attrs.classStudents) {
          stud.decision_number = val;
        }
        this.forceRerender();
        this.selectedDecionNumberDialog = false;
      }
    },
    _addBulkDecision() {
      this.$swal
        .fire({
          title: "Шийдвэр сонгоx",
          text: "Бүгдийг сонгосоноор нөxөx",
          input: "select",
          inputOptions: this.decisionOptions,
          inputPlaceholder: "Шийдвэр сонгоно уу!",
          showCancelButton: true,
          customClass: {
            title: "modal-title",
            input: "centered-input",
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-danger",
          },
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            //
            console.log(
              "Entered number:",
              result,
              this.decisionOptions[result.value]
            );
            for (var stud of this.$attrs.classStudents) {
              stud.decision = this.decisionOptions[result.value];
            }
            this.forceRerender();
          }
        });
    },
    _addBulkNextClassGroup() {
      if (this.nextClassGroups) {
        this.selectedNextClassGroupDialog = true;
      }
    },
    _checkFinalRegisterState() {
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/student/progression/list/" +
        this.$attrs.selectedClassGroup.STUDENT_GROUP_ID;
      console.log("urlLink: ", urlLink);
      //ftodo
      axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/getEsis",
          {
            url: urlLink,
            token: this.$attrs.tokenData.token,
          }
        )
        .then((res) => {
          console.log(res.data.SUCCESS_CODE, res.data.RESULT, res);
          // if (res && res.data && res.data.SUCCESS_CODE == 200) {

          // }
          this.$swal.fire("Амжилттай", res.data.RESPONSE_MESSAGE, "success");
        });
    },
    async _deleteFromESIS(item) {
      console.log(item, item.PERSON_ID);
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/student/progression/delete";
      console.log("writing to...", urlLink);
      var bodyData = {
        studentGroupId: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
        personId: item.PERSON_ID,
      };
      console.log(this.$attrs.tokenData.token);
      await this.writeToESIS(urlLink, bodyData);
    },
    async _sendRequest() {
      // this.$swal.fire("Success", "Request sent successfully", "success");
      // this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/stdnt/progression/request";
      console.log("writing to...", urlLink);
      var bodyData = {
        inStudentGroupID: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
      };
      this.writeToESIS(urlLink, bodyData);
    },
    async _saveToESIS() {
      // this.$swal.fire("Success", "Data saved successfully", "success");
      // this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
      var inStudentList = [];
      // var counter = 0;
      var stud = this.$attrs.classStudents[0];
      var tmpDecision_number = stud.decision_number;
      var tmpReason = stud.reason;
      var tmpNextClassGroup = stud.nextClassGroup;

      console.log(
        stud.FIRST_NAME,
        stud.decision_number,
        stud.decision,
        stud.reason
      );
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/stdnt/progression/save";

      console.log("writing to...", urlLink);
      for (const stud of this.$attrs.classStudents) {
        // console.log(
        //   stud.FIRST_NAME,
        //   stud.decision_number,
        //   stud.decision,
        //   stud.reason
        // );
        // counter++;
        var tmpStud = {
          person_id: Number(stud.PERSON_ID),
          // student_group_id: stud.nextClassGroup.STUDENT_GROUP_ID,
          student_group_id: tmpNextClassGroup
            ? tmpNextClassGroup.STUDENT_GROUP_ID
            : stud.nextClassGroup.STUDENT_GROUP_ID,
          decision_number: tmpDecision_number,
          action_id: tmpReason.action_id,
          action_Reason_id: tmpReason.action_Reason_id,
          //decision_number: stud.decision_number,
          // action_id: stud.reason.action_id,
        };
        inStudentList.push(tmpStud);
        console.log(tmpStud);

        // if (counter == 1)
        //   console.log({
        //     person_id: Number(stud.PERSON_ID),
        //     // student_group_id: stud.nextClassGroup.STUDENT_GROUP_ID,
        //     decision_number: stud.decision_number,
        //     action_id: stud.reason.action_id,
        //     action_Reason_id: stud.reason.action_Reason_id,
        //   });

        //if successfull update firebase
        // var batch = fb.db.batch();
        // for (var student of this.$attrs.classStudents) {
        //   batch.update(student.ref, {
        //     devshiltDecisionNumber: student.decision_number,
        //     devshiltDecision: student.decision,
        //     devshiltReason: student.reason,
        //     nextClassGroupId: student.nextClassGroup
        //       ? student.nextClassGroup
        //       : null,
        //     savedAt: new Date(),
        //     savedToESISAt: new Date(),
        //     savedToESIS: true,
        //   });
        // }
      }
      var bodyData = {
        inStudentGroupID: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
        inStudentList: inStudentList,
      };
      console.log(bodyData, "bodyData");
      await this.writeToESIS(urlLink, bodyData);
      //selectedNextClassGroup
    },
    timeDifference(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diffMs = end - start;

      // const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      return `${minutes}m ${seconds}s`;
    },
    async writeToESIS(urlLink, bodyData) {
      var startTime = new Date();
      await axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/esisWrite",
          {
            url: urlLink,
            token: this.$attrs.tokenData.token,
            data: bodyData,
          }
        )
        .then((res) => {
          this.loading = false;
          var diff = this.timeDifference(startTime, new Date());
          console.log(
            "RESPONSE from ESIS",
            res,
            res.status == 200,
            res.data.SUCCESS_CODE
          );
          this.saveESISresponse = res;
          this.$swal.fire({
            title: res.data.RESPONSE_MESSAGE,
            text: res.data.RESULT + "<p>" + diff + "</p>",
          });
          // this.showSaveESISResponseDialog = !this.showSaveESISResponseDialog;
        })
        .catch((error) => {
          console.log(this.$attrs.tokenData.token);
          console.log(bodyData);
          console.error("Error:", error);
          this.$swal.fire({
            title: error.code,
            text: error.response.data,
            icon: "error",
          });
          //errorhandling write to firebase
        });
    },
  },
};
</script>
<!-- if saved successfull then, saved to firebase etwas -->
